import { Box, Typography } from "@mui/material"
import React from "react"
import { ReactComponent as CompanyIcon } from "../reusable/faded-icon.svg"

const NotFound = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{
      height: "100%",
      width: "100%",
      backgroundColor: "#F9F6F0"
    }}>
      <CompanyIcon />
      <Typography variant="h1" sx={{
        marginTop: "12px"
      }}>404</Typography>
      <Typography variant="h2" sx={{
        marginTop: "12px"
      }}>Page Not Found</Typography>
    </Box>
  )
}

export default NotFound